export const showcaseVideos = [
  { id: 1, title: "НОВОЕ НАЧАЛО", thumb: "/landing2.0/HRC23RjFmBI.jpg", videoId: "HRC23RjFmBI" },
  { id: 2, title: "2023-06-25_03.37.11.mp4", thumb: "/landing2.0/d31WbePYOEg.jpg", videoId: "d31WbePYOEg" },
  { id: 3, title: "НАС НАКРЫЛИ", thumb: "/landing2.0/vkLXRDLTAdI.jpg", videoId: "vkLXRDLTAdI" },
  { id: 4, title: "ЗДЕСЬ СТОЛЬКО П*РНО!", thumb: "/landing2.0/GaoXc4LK-lo.jpg", videoId: "GaoXc4LK-lo" },
  { id: 5, title: "ЭТО ТЫ НАРИСОВАЛ?!", thumb: "/landing2.0/i8H_yStpCTU.webp", videoId: "i8H_yStpCTU" },
  { id: 6, title: "Трейлер", thumb: "/landing2.0/pwItMiuxS_o.jpg", videoId: "pwItMiuxS_o" },
  { id: 7, title: "Конец 6 сезона", thumb: "/landing2.0/e658hi2SctE.jpg", videoId: "e658hi2SctE" },
];